import DatabaseIcon from "~/components/icons/svg/DatabaseIcon.svg?react";
import DashboardIcon from "~/components/icons/svg/DashboardIcon.svg?react";
import type React from "react";

type DashboardSectionConfig = {
    title: string
    icon: React.ReactNode
}

export type DashboardSection =
    'sit'
    | 'chat'
    | 'data_1'
    | 'insights_2'
    | 'no_section'
    ;

export function getDashboardSectionConfig(section: DashboardSection): DashboardSectionConfig | null {
    switch (section) {
        case 'data_1':
            return {title: 'Data Foundation', icon: <DatabaseIcon className="header-icon"/>};
        case 'insights_2':
            return {title: 'Actionable Insights', icon: <DashboardIcon className="header-icon"/>};
    }
    return null;
}
